import { Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import * as moment from 'moment';
import { MemberService } from 'src/app/services/core/member/member.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { timeCalculation, timeZone } from 'src/app/utils/utils.common';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-trip-monitoring',
  templateUrl: './trip-monitoring.component.html',
  styleUrls: ['./trip-monitoring.component.css']
})
export class TripMonitoringComponent implements OnInit {
  currentPage = 1;
  trips:any = [];
  todayDate:any;
  selectedStatus: any = ['scheduled','offered','alarming','onway','arrived','in_progress']
  // preMembers:any = {};
  preLevelOfService:any = {};
  preSpacetypes:any = {};
  timeZone:any = timeZone;

  allTrips:any
  memberNotesObj:any;
  tripId:any;
  user:any;
  destroyedRef = inject(DestroyRef);
  statusList: any = [
    { value: 'scheduled', label: 'Scheduled', disabled: true },
    { value: 'offered', label: 'Offered', disabled: true },
    { value: 'completed', label: 'Completed', disabled: false },
    { value: 'cancelled', label: 'Cancelled', disabled: false },
    { value: 'arrived', label: 'Arrived', disabled: false },
    { value: 'in_progress', label: 'In Progress', disabled: false },
    { value: 'alarming', label: 'Alarming', disabled: false },
    { value: 'onway', label: 'Onway', disabled: false },
    { value: 'reroute', label: 'Reroute', disabled: false },
  ];
  search:any = ''
  @ViewChild('timer', { static: true }) timer:any;
  duration = 15 * 1000; // 10 seconds
  statusChangeSubject = new Subject<any>();



  constructor(
    private spaceTypeService : SpaceTypeService,
    private levelOfService : LosService,
    private memberService : MemberService,
    private tripService: TripService,
    private sharedDataService: SharedDataService
  ){}

  ngOnInit() {
    this.getUser();

    this.statusChangeSubject.pipe(
      debounceTime(2000),
      distinctUntilChanged()
    ).subscribe((status) => {
      this.selectedStatus = status;
      this.getAllTrips(1);
    });
  }

  getUser() {
        this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
          if (data) {
            this.user = data;
            if(this.user.timeZone) {
              this.timeZone = this.user.timeZone;
            }
            this.todayDate = [
              moment().tz(this.timeZone).startOf("day"),
              moment().tz(this.timeZone).endOf("day"),
            ];
            // this.getAllMembers();
            this.getLevelOfService();
            this.getSpaceTypes();
            this.getAllTrips(this.currentPage);
          }
    
        })
  }

  formatToTitleCase(text: string): string {
    if (!text) return text;
    return text
    .replace(/_/g, ' ')  
    .replace(/\w\S*/g, (txt) => 
      txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase()
    );
  }


  ngAfterViewInit(): void {
    this.timer.start();
    // this.getAllTrips();
  }


  getAllTrips(page: any) {
    let queryparams = {
      limit: 50,
      page,
      status: this.apiStatus,
      time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()]
    }
  
    this.tripService.getOperationTrips(queryparams).pipe(untilDestroyed(this))
    .subscribe((data: any) => {
      if (data) {
        this.allTrips = data;
        Object.keys(this.allTrips).forEach(status => {
          const trips = this.allTrips[status];
          if (trips && trips.length) {
            trips.forEach((trip: any) => {
              const { member } = trip;
              if(member) {
                member.displayName = member.firstName + ' ' + member.lastName;
                member.formattedContactNumber = this.formatPhoneNumber(member.contactNumber);
              }
              trip.formattedReference = trip.reference ? `${trip.reference}-${trip.suffix ? trip.suffix : ''}` : '';
           
            });
          }
        });
      }
      this.timer.start();
    })
  }

  private formatPhoneNumber(value: string): string {
    let areaCode;
    let prefix;
    let line;
    
    if (value.length >= 10) {
      areaCode = value.slice(value.length - 10, value.length - 7);
      prefix = value.slice(value.length - 7, value.length - 4);
      line = value.slice(value.length - 4, value.length);
    }

    return value && value.length >= 10 ? `(${areaCode}) ${prefix}-${line}` : value;
  }


  // getAllMembers(){
  //   this.memberService.getPickerMembers({limit:999})
  //   .pipe(untilDestroyed(this)).subscribe((data:any)=>{
  //     if(data){
  //       if (data && data.results) {
  //         this.preMembers = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
  //       }
  //     }
  //   })
  // }

  getLevelOfService(){
    let queryParams = {
      limit: 9999,
      isActive: true,
    }
    this.levelOfService.getPicker(queryParams)
    .pipe(untilDestroyed(this)).subscribe((data:any)=>{
      if(data && data.results){
        this.preLevelOfService = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  getSpaceTypes(){
    let queryParams = {
      limit: 9999,
      isActive: true,
    }
    this.spaceTypeService.getPicker(queryParams)
    .pipe(untilDestroyed(this)).subscribe((data:any)=>{
      if(data && data.results){
        this.preSpacetypes = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

onStatusChange(status: any) {
  this.timer.complete();
  this.statusChangeSubject.next(status);
}

   onDateChange(event:any) {
      this.todayDate = [
        event[0],
        event[1].endOf("day"),
      ];
      this.getAllTrips(this.currentPage);
    }

    onTimerComplete(): void {
      this.timer.init()
      this.getAllTrips(this.currentPage = 1);
  
    }
    openNotesModal(memberNotes: any) {
      this.memberNotesObj = memberNotes;
    }
    opendetailModal(trip: any) {
      this.tripId = trip._id;
    }

    capitalizeLabels(item: string): string {
      if (!item) return '';
      return item.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
    }

  get apiStatus() {
    return this.selectedStatus.filter((status: any) => status !== 'alarming');
  }

}
